import styled from "styled-components";

export const StyledButton = styled.button<{ backgroundcolor?: string, colorfont: string }>`
  border: none;
  background-color: ${props => props.backgroundcolor};
  color: ${props => props.colorfont};
  width: fit-content;
  display: inline-flex;
  height: 38px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 24px;
  border-radius: 30px;
  cursor: pointer;
  border: none;

  text-align: center;
  white-space: nowrap;
  font-family: "InterTight-Bold", Helvetica;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 20px;
  font-style: normal;

  @media screen and (max-width: 1000px){
    width: 100%;
    padding: 24px;
  }

  &:disabled {
    background-color: ${props => props.theme.colors.line};
    cursor: default;
  }

`;